import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken, setToken, removeToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { tansParams } from "@/utils/ruoyi";
let access_token = getToken("access-token")
// let access_token = getToken("access_token")
// let refresh_token = getToken("refresh_token")

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 20000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  // if (getToken("access_token") && getToken("refresh_token") && !isToken) {
  //   config.headers['access_token'] = getToken("access_token",) // 让每个请求携带自定义token 请根据实际情况自行修改
  //   config.headers['refresh_token'] = getToken("refresh_token",) // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // alert(code)
  // 获取错误信息
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (code !== 200) {
    removeToken("access-token");
    // removeToken("access_token");
    // removeToken("refresh_token");
  }
  //401
  if (code === 401) {
    // removeToken("access_token");
    // removeToken("refresh_token");
    
    MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
      confirmButtonText: '重新登录',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(
      () => {
        
        // let link = window.location.href.split('?')[0]
        // window.location.href = 'http://login-pre.uniontech.com/logout?callback=' + link
        //     // window.location.href = ' http://login-dev.uniontech.com/logout?callback=http://10.4.10.108/dev'
        //     //步骤一:创建异步对象
        var ajax = new XMLHttpRequest();
        //步骤二:设置请求的url参数,参数一是请求的类型,参数二是请求的url,可以带参数,动态的传递参数starName到服务端
        ajax.open('delete', '/devprod-api/store-dev-auth/logout');
        // ajax.setRequestHeader("access_token", access_token);
        // ajax.setRequestHeader("refresh_token", refresh_token);
        //步骤三:发送请求
        ajax.send();
        //步骤四:注册事件 onreadystatechange 状态改变就会调用
        ajax.onreadystatechange = function () {
          if (ajax.readyState == 4 && ajax.status == 200) {
            //步骤五 如果能够进到这个判断 说明 数据 完美的回来了,并且请求的页面是存在的
            removeToken("access-token")
            // removeToken("access_token")
            // removeToken("refresh_token")
            // delCookie("access_token")
            // delCookie("refresh_token")
            let obj = JSON.parse(ajax.responseText).datas
            window.location.href = obj.account_logout_url + "?callback=" + obj.callback_url
            // console.log(obj); //输入相应的内容
          }
        }
        // let link = window.location.href.split('?')[0]
        // window.open(link, "_self")
      }
    )
    return Promise.reject(401)
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code !== 200) {
    Notification.error({
      title: msg
    })
    return Promise.reject('error')
  } else {
    return res.data
  }
},
  error => {
    console.log('err' + error)
    removeToken("access-token");
    // removeToken("access_token");
    // removeToken("refresh_token");
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      // removeToken("access_token");
      // removeToken("refresh_token");
      // // alert(getToken("refresh_token"))
      // login().then(res => {
      //     if (res.status === 200) {
      //         window.open(res.datas, "_self")
      //     } else {
      //         Message.error(res.desc)
      //     }

      // }).catch(error => {
      //     Message.error(error)
      // })

      message = "系统接口" + message.substr(message.length - 3) + "异常";

      // return
    }

    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 通用下载方法 
export function download(url, params, filename) {
  return service.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  }).then((data) => {
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}

export default service